import { FC, useCallback } from "react";
import { get } from "lodash";
import { BiTrash, BiAddToQueue } from "react-icons/bi";
import SortableTree, { changeNodeAtPath } from "react-sortable-tree";
import { Select, Checkbox } from "antd";
import { PERMISSIONS } from "@lhd/constants";
import useDiagram, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const DiagramLayout: FC<Props> = ({
  showPrefecture,
  showPermission,
  prefectureOptions,
  treeData,
  placeholder = "会社名を入力ください",
  isLoading,
  setTreeData,
  updateTreeData,
  removeNode,
  selectThis,
  insertNewNode,
}) => {
  const getNodeKey = ({ treeIndex }: any) => treeIndex;
  const reoder = useCallback((trees: any) => {
    return trees.map((tr: any, row_order_position: number) => {
      delete tr.sort_index;
      if (tr.children.length > 0) {
        return {
          ...tr,
          row_order_position,
          action: "update",
          children: reoder(tr.children),
        };
      } else {
        return { ...tr, row_order_position, action: "update" };
      }
    });
  }, []);
  return (
    <Styles>
      {/* {showPrefecture && (
        <div className="header">
          <h3>支店</h3>
          <h3>社会保険料率 支部</h3>
        </div>
      )} */}
      <SortableTree
        isVirtualized={false}
        onChange={updateTreeData}
        canDrag={(props: any) => props.node.isDrag}
        onMoveNode={({ treeData, path, node }) => {
          const result: any = changeNodeAtPath({
            treeData: treeData,
            path: path,
            getNodeKey,
            newNode: {
              ...node,
              action: get(node, "action") === "create" ? "create" : "update",
            },
          });
          setTreeData(reoder(result));
        }}
        treeData={treeData}
        generateNodeProps={({ node, path }: any) => {
          return {
            title: (
              <form
                onClick={(e: any) => {
                  // e.preventDefault();
                  e.stopPropagation();
                  selectThis(node, path);
                }}
              >
                <div className="form-left">
                  <input
                    value={node.title as any}
                    placeholder={placeholder}
                    onChange={(event) => {
                      const title = event.target.value;
                      const result: any = changeNodeAtPath({
                        treeData: treeData,
                        path,
                        getNodeKey,
                        newNode: {
                          ...node,
                          action:
                            get(node, "action") === "create"
                              ? "create"
                              : "update",
                          title,
                        },
                      });
                      setTreeData(result);
                    }}
                  />

                  {showPrefecture && (
                    <Select
                      loading={isLoading}
                      placeholder="都道府県を選択ください"
                      style={{ width: 120 }}
                      defaultValue={node.prefecture_id}
                      onChange={(value) => {
                        const prefecture_id = value;
                        const result: any = changeNodeAtPath({
                          treeData: treeData,
                          path,
                          getNodeKey,
                          newNode: {
                            ...node,
                            action:
                              get(node, "action") === "create"
                                ? "create"
                                : "update",
                            prefecture_id,
                          },
                        });
                        setTreeData(result);
                      }}
                      options={prefectureOptions || []}
                      className="branch-prefecture"
                    />
                  )}

                  <div className="group-btn">
                    {insertNewNode && (
                      <button
                        className="btn-add-node"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          insertNewNode(path);
                        }}
                      >
                        <BiAddToQueue />
                      </button>
                    )}

                    {node.isDelete && (
                      <button
                        className="btn-remove-node"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          removeNode(node, path);
                        }}
                      >
                        <BiTrash />
                      </button>
                    )}
                  </div>
                </div>

                {showPermission && (
                  <>
                    <Checkbox.Group
                      style={{ width: "100%" }}
                      className="checkbox-wrapper"
                      value={node.role_types}
                      onChange={(values) => {
                        const result: any = changeNodeAtPath({
                          treeData: treeData,
                          path,
                          getNodeKey,
                          newNode: {
                            ...node,
                            action:
                              get(node, "action") === "create"
                                ? "create"
                                : "update",
                            role_types: values,
                          },
                        });
                        setTreeData(result);
                      }}
                    >
                      <Checkbox
                        value={PERMISSIONS["human_resource_management"]}
                      >
                        人事管理
                      </Checkbox>
                      <Checkbox value={PERMISSIONS["labor_management"]}>
                        労務管理
                      </Checkbox>
                      <Checkbox value={PERMISSIONS["company_management"]}>
                        会社組織管理
                      </Checkbox>
                      <Checkbox value={PERMISSIONS["operational_management"]}>
                        運営管理
                      </Checkbox>
                      <Checkbox value={PERMISSIONS["full_permission"]}>
                        全権限
                      </Checkbox>
                    </Checkbox.Group>
                  </>
                )}
              </form>
            ),
          };
        }}
      />
    </Styles>
  );
};

const Diagram: FC<ReceivedProps> = (props) => (
  <DiagramLayout {...useDiagram(props)} />
);

export default Diagram;
